export default "__VITE_ASSET__DKwBqs0C__"